export default {
    data() {
        return {
            items: [],
            currentPage: 1,
            loading: false,
            showDetails: false,
            showDetailsV1: false,
            isAdding: false,
            isEditing: false,
            isSaving: false,
            isValidating: false,
            isLoadingDetails: false,
            dataLanguage: 'en',
            viewModel: (this.newViewModel ? this.newViewModel : { errors: {} }),
            isReadOnly: false,
            originalViewModel: null,
            startRow: 0,
            endRow: 0
        }
    },
    computed: {
        offset: () => (moment().utcOffset() * -1),
        viewModelChanged: function () {
            var vmModified = this.initializeModifiedViewModel();
            return JSON.stringify(vmModified) != this.originalViewModel;
        },
    },
    methods: {
        hasError: function (vmProperties) {
            let warn = false;
            vmProperties.forEach((property, index) => {
                if (this.viewModel.errors[property]) {
                    warn = true;
                }
            });

            return warn ? 'section-has-error' : '';
        },
        replaceNewLine: function (text) {
            let returnVal = "";
            if (text) {
                returnVal = text.replace("\r\n", "<br>").replace("\n", "<br>").replace("\r", "<br>");
            }
            return returnVal;
        },
        add: function () {
            this.dataLanguage = 'en';
            this.viewModel = this.newViewModel();
            this.initializeOriginalViewModel();

            this.isAdding = true;
            this.isEditing = false;
            this.showDetails = true;
        },
        edit: function (id) {
            this.dataLanguage = 'en';
            this.isAdding = false;
            this.isEditing = true;
            this.isLoadingDetails = true;
            this.viewModel = { errors: {} };

            this.getByIdFunc({ id: id })
                .then((viewModel) => {
                    viewModel.errors = {};
                    this.viewModel = viewModel;
                    this.showDetails = true;
                    this.isLoadingDetails = false;
                });
        },
        deleteItem: function (id) {
            this.$buefy.dialog.confirm({
                message: window.messages.confirmDelete,
                onConfirm: () => {
                    this.deleteFunc({ id: id })
                        .then((viewModel) => {
                            this.refreshList();
                        });
                }
            });
        },
        save: function () {
            this.isSaving = true;
            const func = this.isAdding
                ? this.createFunc
                : this.editFunc;

            func(this.viewModel)
                .then((response) => {
                    this.isSaving = false;
                    if (response.status === 400) {
                        this.viewModel.errors = response.data.errors;
                    }
                    else {
                        this.showDetails = false;
                        this.refreshList();
                    }
                });
        },
        getDataSourceText: (dataSource, value) => {
            if (dataSource) {
                const item = dataSource.filter(item => item.value == value)[0];
                return !item ? "" : item.text;
            }
            return "";
        },
        formatDate: function (value) {
            if (value) {
                const localDate = moment(value).local();
                return localDate.format("YYYY-MM-DD");
            }
        },
        initializeOriginalViewModel: function () {
            var vmModified = this.initializeModifiedViewModel();
            this.originalViewModel = JSON.stringify(vmModified);
        },
        initializeModifiedViewModel: function () {
            var excludedProperties = ['id', 'errors', 'savingIdentifier', 'validateUrlLinks'];
            var vmModified = Object.assign({}, this.viewModel);
            excludedProperties.forEach(item => delete vmModified[item]);

            return vmModified;
        },
        getUrlParameter: function (paramName) {
            const url = new URL(window.location.href);
            return url.searchParams.get(paramName);
        },
        setUrlParameter: function (tableModel, excludedParams, isRemoveExistingParams) {
            let url = window.location.pathname;
            if (isRemoveExistingParams) {
                url = url.split('?')[0];
            }

            let qs = '';
            if (tableModel) {
                for (const [key, value] of Object.entries(tableModel)) {
                    if (excludedParams) {
                        if (!excludedParams.includes(key)) {
                            qs = this.generateQueryString(qs, key, value);
                        }
                    } else {
                        qs = this.generateQueryString(qs, key, value);
                    }
                }
            }

            if (qs) {
                window.history.pushState({}, '', url + '?' + qs);
            }
            else {
                window.history.pushState({}, '', url);
            }
        },
        generateQueryString: function (qs, paramName, value) {
            if (Array.isArray(value) && value.length > 0) {
                if (qs) qs += '&';
                qs += `${paramName}=${encodeURIComponent(value.join(','))}`;
            } else if (!Array.isArray(value) && value) {
                if (qs) qs += '&';
                qs += `${paramName}=${encodeURIComponent(value)}`;
            }

            return qs;
        },
        setFilterModelFromUrlParameter: function (filterTableModel) {
            let result = filterTableModel;

            for (const [key, value] of Object.entries(filterTableModel)) {
                var paramVal = this.getUrlParameter(key);

                if (paramVal) {
                    if (Array.isArray(value)) {
                        result[key] = paramVal.split(',');
                    } else {
                        result[key] = paramVal;
                    }
                }
            }

            return result;
        },
        removeUrlParameters: function () {
            let url = window.location.pathname;
            url = url.split('?')[0];
            window.history.pushState({}, '', url);
        }
    },
    watch: {
        showDetails: function (val) {
            if (!val) {
                this.isAdding = false;
                this.isEditing = false;
            }
        }
    },
}